import React from "react";
import './ListingItem.scss';

const ListingItem = ({ title }) => {

  return <div className="registration-listing-item">
    <img src="/images/registration/GreenTick.svg" />
    <pre className="registration-listing-item-title">{title}</pre>
  </div>
}

export default ListingItem;